export default "__VITE_ASSET__BZlJydvR__"